export default "__VITE_ASSET__DjBc5rMa__"